import { __assign, __extends } from "tslib";
import { PricingServiceException as __BaseException } from "./PricingServiceException";
export var AttributeValue;
(function (AttributeValue) {
    AttributeValue.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AttributeValue || (AttributeValue = {}));
export var DescribeServicesRequest;
(function (DescribeServicesRequest) {
    DescribeServicesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeServicesRequest || (DescribeServicesRequest = {}));
export var Service;
(function (Service) {
    Service.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Service || (Service = {}));
export var DescribeServicesResponse;
(function (DescribeServicesResponse) {
    DescribeServicesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeServicesResponse || (DescribeServicesResponse = {}));
var ExpiredNextTokenException = (function (_super) {
    __extends(ExpiredNextTokenException, _super);
    function ExpiredNextTokenException(opts) {
        var _this = _super.call(this, __assign({ name: "ExpiredNextTokenException", $fault: "client" }, opts)) || this;
        _this.name = "ExpiredNextTokenException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ExpiredNextTokenException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ExpiredNextTokenException;
}(__BaseException));
export { ExpiredNextTokenException };
var InternalErrorException = (function (_super) {
    __extends(InternalErrorException, _super);
    function InternalErrorException(opts) {
        var _this = _super.call(this, __assign({ name: "InternalErrorException", $fault: "server" }, opts)) || this;
        _this.name = "InternalErrorException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalErrorException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return InternalErrorException;
}(__BaseException));
export { InternalErrorException };
var InvalidNextTokenException = (function (_super) {
    __extends(InvalidNextTokenException, _super);
    function InvalidNextTokenException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidNextTokenException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidNextTokenException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidNextTokenException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return InvalidNextTokenException;
}(__BaseException));
export { InvalidNextTokenException };
var InvalidParameterException = (function (_super) {
    __extends(InvalidParameterException, _super);
    function InvalidParameterException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidParameterException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidParameterException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidParameterException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return InvalidParameterException;
}(__BaseException));
export { InvalidParameterException };
var NotFoundException = (function (_super) {
    __extends(NotFoundException, _super);
    function NotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "NotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "NotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NotFoundException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return NotFoundException;
}(__BaseException));
export { NotFoundException };
export var GetAttributeValuesRequest;
(function (GetAttributeValuesRequest) {
    GetAttributeValuesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetAttributeValuesRequest || (GetAttributeValuesRequest = {}));
export var GetAttributeValuesResponse;
(function (GetAttributeValuesResponse) {
    GetAttributeValuesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetAttributeValuesResponse || (GetAttributeValuesResponse = {}));
export var FilterType;
(function (FilterType) {
    FilterType["TERM_MATCH"] = "TERM_MATCH";
})(FilterType || (FilterType = {}));
export var Filter;
(function (Filter) {
    Filter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Filter || (Filter = {}));
export var GetProductsRequest;
(function (GetProductsRequest) {
    GetProductsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetProductsRequest || (GetProductsRequest = {}));
export var GetProductsResponse;
(function (GetProductsResponse) {
    GetProductsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetProductsResponse || (GetProductsResponse = {}));
